var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterOrEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02504 2.55004C5.27357 2.21867 5.74367 2.15152 6.07504 2.40004L12.075 6.90004C12.2639 7.04169 12.375 7.26398 12.375 7.50004C12.375 7.73611 12.2639 7.9584 12.075 8.10004L6.07504 12.6C5.74367 12.8486 5.27357 12.7814 5.02504 12.45C4.77652 12.1187 4.84367 11.6486 5.17504 11.4L10.375 7.50004L5.17504 3.60004C4.84367 3.35152 4.77652 2.88142 5.02504 2.55004ZM4.87504 15C4.87504 14.5858 5.21083 14.25 5.62504 14.25H12.375C12.7893 14.25 13.125 14.5858 13.125 15C13.125 15.4143 12.7893 15.75 12.375 15.75H5.62504C5.21083 15.75 4.87504 15.4143 4.87504 15Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterOrEqual);
export default __webpack_public_path__ + "static/media/greater_or_equal.c6de05036c36d4b25531be98b1085c24.svg";
export { ForwardRef as ReactComponent };